import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.5 10a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0m2.5-.833a.833.833 0 1 0 0 1.667.833.833 0 0 0 0-1.667",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.167 10a5.833 5.833 0 1 1 11.666 0 5.833 5.833 0 0 1-11.666 0M10 5.835a4.167 4.167 0 1 0 0 8.333 4.167 4.167 0 0 0 0-8.333",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10 .834a9.167 9.167 0 1 0 0 18.333A9.167 9.167 0 0 0 10 .834m-7.5 9.167a7.5 7.5 0 1 1 15 0 7.5 7.5 0 0 1-15 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }